import React from 'react';
import './map.css';
import 'leaflet/dist/leaflet.css';
import MapWithTable from './MapWithTable';


function MapWithSidePanel() {
  return (
    <div>
      <div
        style={{
          color: 'black',
          fontWeight: 'bold',
          
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: '#aad3df'
        }}
      >
        ASSET REALTIME TRACKING SYSTEM
      </div>
      <MapWithTable />
    </div>
  );
}

export default MapWithSidePanel;
